import axios from 'axios';

import { TagGetRequest, TagGetResponse, TagParams } from '../model/commonModel';

export const CommonApi = {
  getTag: (params: TagParams) => {
    return axios.get<TagGetResponse>(`/api/tags/${params.id}`);
  },
  getTags: (params: TagGetRequest) => {
    return axios.get<TagGetResponse[]>('/api/tags', params);
  },
};
